import { useEffect, useState } from 'react'

/**
 * Tokenbrug van CSS naar three.js.
 *
 * De merkkleuren staan één keer, als CSS custom properties in
 * styles/tokens.css. Deze hook leest ze uit en geeft ze door aan de
 * materialen, zodat de 3D-scène geen eigen kopie van diezelfde hex bijhoudt —
 * wijzigt het rood, dan wijzigt de scène mee zonder dat iemand twee plekken
 * hoeft te vinden.
 */
export interface MerkTokens {
  brand: string
  brandD: string
  brandInk: string
  hi: string
  ok: string
  bad: string
  data: string
  ink: string
  muted: string
  bg: string
}

const LEES: Record<keyof MerkTokens, string> = {
  brand: '--brand',
  brandD: '--brand-d',
  brandInk: '--brand-ink',
  hi: '--hi',
  ok: '--ok',
  bad: '--bad',
  data: '--k-data',
  ink: '--ink',
  muted: '--muted',
  bg: '--bg',
}

/**
 * Terugval als getComputedStyle nog niets teruggeeft (eerste frame, tests).
 * Deze waarden zijn exact wat er in styles/tokens.css staat — de enige plek
 * waar ze bewust dubbel voorkomen. Wijzigt tokens.css, wijzig deze regel mee.
 */
const TERUGVAL: MerkTokens = {
  brand: '#E8213A', brandD: '#AA0020', brandInk: '#F4A9B4', hi: '#FFC72C',
  ok: '#77B342', bad: '#E5684B', data: '#468CC4',
  ink: '#ECECEE', muted: '#9C9CA4', bg: '#141416',
}

export function useMerkTokens(): MerkTokens {
  const [tokens, setTokens] = useState<MerkTokens>(TERUGVAL)

  useEffect(() => {
    const wortel = document.querySelector('.kiosk') ?? document.documentElement
    const stijl = getComputedStyle(wortel)
    const gelezen = { ...TERUGVAL }
    let ietsGevonden = false

    for (const sleutel of Object.keys(LEES) as (keyof MerkTokens)[]) {
      const waarde = stijl.getPropertyValue(LEES[sleutel]).trim()
      if (waarde) {
        gelezen[sleutel] = waarde
        ietsGevonden = true
      }
    }
    if (ietsGevonden) setTokens(gelezen)
  }, [])

  return tokens
}
